/* eslint-disable arrow-body-style */
/* eslint-disable padding-line-between-statements */
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import _, { update } from 'lodash';
import PropTypes from 'prop-types';
import React, { useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { DateField, useModal } from '@jutro/components';
import { messages as commonMessages } from '@xengage/gw-platform-translations';
import { ENTGatewayDocumentService } from 'ent-capability-gateway-document';
import metadata from './TFPADocumentsAccordion.metadata.json5';
import styles from './TFPADocumentsAccordion.module.scss'

import { Link } from '@jutro/router';

const TFPADocumentsAccordion = props => {
    const {
        onTabChangeObj,
        jobNumber
    } = props;

    const { showAlert } = useModal();
    

    const onDownloadDocument = useCallback(item => {
        try {
            const downloadURL = ENTGatewayDocumentService.downloadDocument(item.docUID, item.sessionID);
            window.location.href = `${downloadURL}&job=${jobNumber}`;
        } catch (error) {
             showAlert({
                 title: commonMessages.errorUploadTitle,
                 message: commonMessages.errorGenerateUploadToken,
                 status: 'error',
                 icon: 'mi-error-outline',
                 confirmButtonText: commonMessages.ok,
             })
             .catch(_.noop);
        } 
    }, [jobNumber, showAlert]);

   const getDocumentName = useCallback((document)=>{
    
       return <Link className={styles.linkStyle} onClick={() => { onDownloadDocument(document) }} > {document.name}</Link>
           
    },[onDownloadDocument])

    const getDocumentUploaded = useCallback((item, index) => (
        <DateField
            id={`uploadedDate${index}`}
            value={item.dateModified}
            readOnly
            displayFormat="vshort"
        />
    ), []);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const overrideProps = {
        '@field': {           
            className:styles.fieldStyle
        },
        documentsTable:{
            data:_.get(onTabChangeObj,'latestJobPolicyPeriod.documentDTOs')
        },
        nameColumn:{
            textAlign: "left"
        }
        
    };


    const resolvers = {
        resolveClassNameMap: styles,
        resolveCallbackMap: {
            getDocumentName,
            getDocumentUploaded
        }
    };


    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            overrideProps={overrideProps}
            model={onTabChangeObj}
            callbackMap={resolvers.resolveCallbackMap}
            classNameMap={resolvers.resolveClassNameMap}
        // componentMap={resolvers.resolveComponentMap}
        />
    );
};


TFPADocumentsAccordion.propTypes = {
    history: PropTypes.shape({
        push: PropTypes.func,
    }).isRequired,
    authHeader: PropTypes.shape({})
};
export default TFPADocumentsAccordion;
